// The specific reasons this module's backend gives, in the four languages.
//
// Two codes travel INSIDE an error and are not the code it is thrown with:
//
//   · `reasons` — what a generic refusal carries in `details.reason` or
//     `details.code` (`ConflictError(…, 'CONFLICT', { reason: 'ALREADY_CLOSED' })`).
//     errorMessage() says it from `errors.reasons.<REASON>` instead of the
//     generic «that record is no longer in the state you expected».
//   · `fields` — the code of each field of a ValidationError, said by
//     fieldErrors() from `errors.fields.<CODE>` instead of «not a valid value».
//
// Generic field codes (EMPTY, IN_THE_FUTURE, NOT_FOUND…) are the shell's and
// are not repeated here. platform/web/tests/errorReasons.test.js reads the
// backend and fails on a code without its four sentences, and on two
// modules saying one code differently (the shell merges them into one).

const errorReasons = {
  es: {
    fields: {
      CANCELLED: 'Ese albarán está anulado',
      NOTHING_TO_STOCK: 'Ninguna línea tiene material y cantidad para entrar en stock',
      NO_DEFAULT_LOCATION: 'Falta la ubicación por defecto para las líneas sin destino',
    },
  },
  ca: {
    fields: {
      CANCELLED: 'Aquest albarà està anul·lat',
      NOTHING_TO_STOCK: 'Cap línia no té material i quantitat per entrar a l’estoc',
      NO_DEFAULT_LOCATION: 'Falta la ubicació per defecte per a les línies sense destinació',
    },
  },
  en: {
    fields: {
      CANCELLED: 'That delivery note is cancelled',
      NOTHING_TO_STOCK: 'No line has a material and a quantity to put into stock',
      NO_DEFAULT_LOCATION: 'There is no default location for the lines with no destination',
    },
  },
  fr: {
    fields: {
      CANCELLED: 'Ce bon de livraison est annulé',
      NOTHING_TO_STOCK: 'Aucune ligne n’a d’article et de quantité à mettre en stock',
      NO_DEFAULT_LOCATION: 'Il n’y a pas d’emplacement par défaut pour les lignes sans destination',
    },
  },
}

/** The module's catalogue with these hung from `errors`, locale by locale. */
export function withErrorReasons(base) {
  const merged = {}
  for (const [locale, catalogue] of Object.entries(base)) {
    const own = errorReasons[locale] ?? {}
    merged[locale] = {
      ...catalogue,
      errors: {
        ...catalogue.errors,
        reasons: { ...catalogue.errors?.reasons, ...own.reasons },
        fields: { ...catalogue.errors?.fields, ...own.fields },
      },
    }
  }
  return merged
}

export default errorReasons
